import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";


import LoadingIcon from 'components/LoadingIcon';
import Button from 'components/inputs/Button';
import Input from 'components/inputs/Input';
import { v2, Hubspot } from 'actions';
import Cookies from 'js-cookie';

const { cmeCoachSendEmail } = v2.cmeCoach;
const { hubspotSubmitCmeCoach } = Hubspot;

export default function CmeCoachSendEmail({ cmeCoach }) {
  const [inputEmail, setInputemail] = useState("");

  const dispatch = useDispatch();

  const onSubmitEmail = (email) => {
    hubspotSubmitCmeCoach(email, Cookies.get('hubspotutk'));
    return dispatch(cmeCoachSendEmail({ email }));
  };

  const onSubmitEmailForm = (ev) => {
    ev.preventDefault();

    onSubmitEmail(inputEmail)
      .then(() => setInputemail(inputEmail))
      .catch(() => {});
  };

  return (
    <div className="send-email-wrapper">
      <div className="send-email-title">
        <h3>Get a copy of your CME requirements for easy reference</h3>
      </div>
      <div className="send-email-form">
        <form onSubmit={ev => onSubmitEmailForm(ev)}>
          <div className="cme-coach-email-form-wrapper d-md-flex mt-4">
            <div className="form-group form-input">
              <Input
                name="cme-coach-email"
                className="input"
                type="email"
                placeholder="Email"
                required
                value={inputEmail}
                onChange={value => setInputemail(value)}
                disabled={cmeCoach.data.isSendingEmail}
              />
            </div>
            <div className="form-group form-button ml-4">
              <Button
                type="submit"
                disabled={cmeCoach.data.isSendingEmail}
              >
                Send
              </Button>
            </div>
            { cmeCoach.data.isSendingEmail && (
            <div className="form-group">
              <LoadingIcon hideLabel />
            </div>
            )}

            {(!cmeCoach.data.isSendingEmail && cmeCoach.data.sendEmailStatus !== null) && (
            <div className="form-group">
                {cmeCoach.data.sendEmailStatus ? "Email sent!" : "There was an error sending your email. Please try again later or with a different email address."}
            </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

CmeCoachSendEmail.propTypes = {
  cmeCoach: PropTypes.object.isRequired
};
